export default __webpack_public_path__ + "static/media/pending_icon.9f201340.svg";